// extracted by mini-css-extract-plugin
export var UpgradeSection = "upgradeSelect-module--UpgradeSection--1mlh3";
export var UpgradeTitle = "upgradeSelect-module--UpgradeTitle--3OEu3";
export var Parent = "upgradeSelect-module--Parent--4OvrM";
export var Card = "upgradeSelect-module--Card--2budV";
export var ImageBox = "upgradeSelect-module--ImageBox--1sYHF";
export var Label = "upgradeSelect-module--Label--3FwWD";
export var Icon = "upgradeSelect-module--Icon--dwZ6w";
export var Active = "upgradeSelect-module--Active--25Mox";
export var Svg = "upgradeSelect-module--Svg--9mtWp";
export var Info = "upgradeSelect-module--Info--AHDpc";
export var Main = "upgradeSelect-module--Main--3j82m";
export var Sub = "upgradeSelect-module--Sub--2gc4S";
export var Button = "upgradeSelect-module--Button--3aEh9";
export var Dot = "upgradeSelect-module--Dot--3GY_i";
export var Text = "upgradeSelect-module--Text--2NtIX";